module.exports = __webpack_public_path__ + "static/media/pre-lesson.2ae8c031.md";